import { Footer2022, Intro2022 } from './components';
import { use2022Page } from './shared';

const JudgesCriteria2022 = () => {
  use2022Page({ cate: 'judges_criteria', lang: 'en', title: 'Smart Living Partnership Awards 2022 - Judging Criteria' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="en" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="JudgesCriteria"><div className="JudgesCriteria_info"><div className="JudgesCriteria_Title">JUDGING CRITERIA</div><div className="JudgesCriteria_TitleLine"><div className="JudgesCriteria_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="AwardCriteria_Table"><div className="AwardCriteria_Details"><p>Innovation and Creativity</p><p>15%</p></div><div className="AwardCriteria_Details"><p>Functionality and Ergonomics</p><p>15%</p></div><div className="AwardCriteria_Details"><p>Quality</p><p>15%</p></div><div className="AwardCriteria_Details"><p>Benefits and Impact</p><p>20%</p></div><div className="AwardCriteria_Details"><p>Market Potential / Performance</p><p>20%</p></div><div className="AwardCriteria_Details"><p>Ecological Compatibility</p><p>15%</p></div></div></div></section>
      <Footer2022 lang="en" />
    </div>
  );
};

export default JudgesCriteria2022;

